import _ from 'underscore';
import Numeral from 'numeral';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_User_Preview from 'view/user_identification/user_preview';
import Model_User_Identification from 'model/user_identification';
import {operators} from 'view/user_identification/segment_edit';

const system_keys = {
    identification: 'User ID',
    email: 'Email',
    display_name: 'Name'
};

export default View.extend({
    className: 'user-segment-overview',

    views: {
        user_preview: {}
    },

    events: {
        'submit .user-search'       : 'onSearchUser',
        'click .segment-edit'       : 'onEdit',
        'click .segment-copy'       : 'onCopy',
        'click .segment-delete'     : 'onDelete',
        'click .segment-reactivate' : 'onReactivate',
        'click .segment-deactivate' : 'onDeactivate'
    },

    dom_handlers: {
        onSearchUser: function(e) {
            var search_val = this.$el.find('[name=search]').val();

            if (search_val) {
                this.search(search_val);
            } else {
                this.search();
            }
        },

        onEdit: function(e) {
            Modals.editUserSegment(this.model.id);
        },

        onCopy: function(e) {
            Modals.copyUserSegment(this.model.id);
        },

        onDelete: function(e) {
            Modals.deleteUserSegment(this.model.id);
        },

        onReactivate: function(e) {
            Modals.reactivateUserSegment(this.model.id);
        },

        onDeactivate: function(e) {
            Modals.deactivateUserSegment(this.model.id);
        }
    },

    event_handlers: {
        onUserDelete: function(model) {
            if (typeof this.views.user_preview['_' + model.id] !== 'undefined') {
                this.views.user_preview['_' + model.id].remove();
                delete this.views.user_preview['_' + model.id];
            }
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);

        this.listenTo(Cache.user_identification, 'remove', this.event_handlers.onUserDelete.bind(this));
    },

    search: function(search_val) {
        Cache.app.request({
            action: 'user_identification/search',
            data: {
                page: 1,
                limit: 30,
                sorder_order: 'desc',
                sort_type: 'last_seen',
                segment_id: this.model ? this.model.id : undefined,
                search: search_val
            },
            success: (response) => {
                // reset
                _.each(this.views.user_preview, (view) => {
                    view.remove();
                });

                this.views.user_preview = {};

                // update count
                if (this.model && !search_val) {
                    this.model.set('count_user', response.total);
                }

                this.$el.find('.user-total').text(Numeral(response.total).format('0,0'));
                this.$el.find('.user-list-count').text(response.data.length + ' of ' + Numeral(response.total).format('0,0') + ' user' + (response.total === 1 ? '' : 's'))

                // create views
                response.data.forEach((data) => {
                    var model = new Model_User_Identification(data);
                    this.views.user_preview['_' + model.id] = new View_User_Preview({model: model});
                    this.views.user_preview['_' + model.id].render().$el.appendTo(this.$el.find('.region-user-list'));
                });

                this.$el.find('.search-result-empty').toggleClass('active', response.data.length === 0);
            }
        });
    },

    render: function() {
        var content = '';

        var users_tab =
        '<form class="user-search search-input-medium search-input-solid">' +
            '<input type="text" name="search" placeholder="Search users">' +
            '<button><i class="far fa-search"></i></button>' +
        '</form>' +
        '<div class="user-list-count"></div>' +
        '<div class="region-user-list"></div>' +
        '<div class="search-result-empty margin-top-12">No users found in this segment</div>';

        if (this.model) {
            var createtor_name = Cache.user.get(this.model.get('created_by')) ? Cache.user.get(this.model.get('created_by')).escape('name') : 'Unknown';

            var segment_condition = this.model.get('segment_condition');
            if (segment_condition) {
                try {
                    segment_condition = JSON.parse(segment_condition);
                } catch(e) {
                    segment_condition = [];
                }
            }

            var condition_html = '';

            segment_condition.forEach((condition) => {
                condition_html += '<li>' + (condition.key ? Util.htmlEntities((system_keys[condition.key] || condition.key)) : '') +  ' <span class="font-weight-semibold italic">' + (operators[condition.operator] || Util.htmlEntities(condition.operator)) + '</span> ' + Util.htmlEntities(condition.value) + '</li>';
            });

            content =
            (Cache.app.isAdmin() ?
            '<div class="button-dropdown sidebar-actions">' +
                '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                '<div>' +
                    '<ul class="dropdown">' +
                        '<li class="segment-edit stop-propagation">Edit</li>' +
                        '<li class="segment-copy stop-propagation">Duplicate</li>' +
                        (this.model.get('is_archived') ?
                        '<li class="segment-reactivate stop-propagation">Reactivate</li>' :
                        '<li class="segment-deactivate stop-propagation">Deactivate</li>') +
                        '<li class="separator"></li>' +
                        '<li class="segment-delete stop-propagation">Delete</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' : '') +

            '<div class="tab">' +
                '<div class="tab-menu">' +
                    '<a href="#" class="active">About</a>' +
                    '<a href="#">Users</a>' +
                '</div>' +
                '<div class="tab-content">' +
                    '<div class="active">' +
                        (this.model.get('is_archived') ?
                        '<div class="badge-secondary-invert badge-small font-weight-medium margin-bottom-12">Deactivated</div>' : '') +
                        '<div class="font-weight-medium">Total Users</div>' +
                        '<div class="user-total"><div class="loader-placeholder" style="width:80px;"></div></div>' +
                        '<div class="text-info">Used in ' + this.model.get('usage_project') + ' projects</div>' +

                        // description
                        (this.model.get('segment_description') ?
                        '<div class="box-neutral margin-top-24">' + Util.nl2br(this.model.escape('segment_description')) + '</div>' : '') +

                        // condition
                        '<div class="box padding-16 margin-top-24">' +
                            '<div>Match ' + (this.model.get('segment_type') === Constants.USER_SEGMENT_TYPE_AND ? 'all' : 'any') + ' of the conditions</div>' +
                            (condition_html ?
                            '<ul class="segment-condition">' + condition_html + '</ul>' : '') +
                        '</div>' +
                        '<div class="text-info">Created ' + Util.moment(this.model.get('created_at'), undefined, undefined, false) + ' by ' + createtor_name + '</div>' +
                    '</div>' +
                    '<div>' +
                        users_tab +
                    '</div>' +
                '</div>' +
            '</div>';
        } else {
            content = users_tab;
        }

        this.$el.html(content);

        this.search();

        return this;
    }
});